const normalizeToken = (value = '') =>
  String(value)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

const isLikelyUid = (value = '') => String(value).trim().length >= 20

const buildOwnerTokens = (ownerValue, owners = []) => {
  const tokens = new Set()

  if (ownerValue && !isLikelyUid(ownerValue)) {
    tokens.add(normalizeToken(ownerValue))
  }

  const ownerMatch = owners.find(({ value }) => value === ownerValue)

  if (ownerMatch?.label) {
    tokens.add(normalizeToken(ownerMatch.label))
  }

  owners.forEach(({ value, label }) => {
    if (value && !isLikelyUid(value)) {
      tokens.add(normalizeToken(value))
    }

    if (label) {
      tokens.add(normalizeToken(label))
    }
  })

  return [...tokens].filter(Boolean)
}

const fieldContainsToken = (fieldValue, token) => {
  if (!fieldValue || !token) {
    return false
  }

  return normalizeToken(fieldValue).includes(token)
}

export const assertNoPublicOwnerLeak = ({ owner, owners = [], publicFields = {} }) => {
  const tokens = buildOwnerTokens(owner, owners)
  const leakedIn = []

  Object.entries(publicFields).forEach(([key, value]) => {
    if (!value) {
      return
    }

    const matched = tokens.find((token) => fieldContainsToken(value, token))

    if (matched) {
      leakedIn.push({ field: key, token: matched })
    }
  })

  return {
    ok: leakedIn.length === 0,
    leakedIn,
  }
}

export default assertNoPublicOwnerLeak
